"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _withoutIdentical = _interopRequireDefault(require("../withoutIdentical"));

var arrayDifference = function (previousList, newList) {
  return {
    added: (0, _withoutIdentical.default)(previousList, newList),
    removed: (0, _withoutIdentical.default)(newList, previousList)
  };
};

var _default = arrayDifference;
exports.default = _default;